export default __webpack_public_path__ + "static/media/b2.1a1ef2ad.jpg";